import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-diagnostic-form-qualification',
  templateUrl: './participant-diagnostic-form-qualification.component.html',
  styleUrls: ['./participant-diagnostic-form-qualification.component.scss']
})
export class ParticipantDiagnosticFormQualificationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
